import { useCustomQuery } from '../../graphql';
import { ApiKeyCacheKey } from './cacheKeys';

export const useApiKeyStatus = () => {
  const { data, isLoading, refetch } = useCustomQuery({
    cacheKey: ApiKeyCacheKey,
    query: GET_API_KEY_STATUS,
    variables: {},
  });

  return {
    apiKey: data?.apiKey?.myApiKey ?? null,
    isLoading,
    refetch,
  };
};

const GET_API_KEY_STATUS = `
  query GET_API_KEY_STATUS {
    apiKey {
      myApiKey {
        keyPrefix
        createdAt
        lastUsedAt
      }
    }
  }
`;
